import { AccountingWorkpadsService_workPadsServiceGetGetWorkPad } from '@festina/life-general-types/life/hooks/AccountingWorkpadsService_workPadsServiceGetGetWorkPad'

export const useFetchWorkPad =
  AccountingWorkpadsService_workPadsServiceGetGetWorkPad.useSuspenseQuery
